// extracted by mini-css-extract-plugin
module.exports = {"signerForm":"styles_signerForm__kfRxt","disabledPill":"styles_disabledPill__fzH46"};